export default __webpack_public_path__ + "1.19.4/static/media/close.2fccb63b.svg";